import gql from "graphql-tag"

export const QUIZ_RESPONSE_FRAGMENT = gql`
  fragment CoveQuizResponseFragment on CoveQuizResponse {
    id
    headachesFrequency
    headachesDuration
    headachesDurationNote
    headacheAttacksCount
    headacheFreeBetweenAttacks
    headacheGoesToMaximumIn
    headachesChangedInLastMonths
    headachesChangedInLastMonthsNotes
    headachesIntensity
    headachesLocation
    headachesLocationOther
    painDescription
    painDescriptionOther
    experiencedTypesOfHeadache
    headacheStartsAfter
    headacheSymptoms
    aurasBuildIn
    associationsWithAura
    familyMembersWithHeadaches
    familyMembersWithHeadachesNotes
    headachesWakeUpAtNight
    timeOfDayWhenHeadachesCome
    lifestyleTriggers
    lifestyleTriggersOther
    environmentalTriggers
    environmentalTriggersOther
    visitedHealthcareDoctor
    diagnosisFromDoctor
    diagnosisFromDoctorOther
    treatmentFromDoctor
    stillTakingTreatmentFromDoctor
    satisfiedTreatment
    stopTreatmentReason
    emergencyRoomReason
    emergencyRoomReasonOther
    hadTests
    tests
    imagingNotes
    bloodTestNotes
    spinalTapNotes
    eyeExamNotes
    otherTestNotes
    everTriedMedication
    multiSelectMedications
    multiSelectMedicationResponses {
      drugName
      dosage
      lastTimeUsed
      effectiveness
      sideEffects
      sideEffectsNotes
      additionalNotes
      doctorPrescribe
      startedTaking
    }
    otherTreatmentWays
    otherTreatmentWaysOther
    otherTreatmentWaysEffective
    otherTreatmentWaysEffectiveNotes
    lifestyleChoices
    lifestyleChoicesNotes
    stressfulEvents
    stressfulEventsOther
    hasDepression
    weight
    height
    bloodPressure
    bloodPressureHigh
    bloodPressureLow
    lastBloodPressureTakenTime
    hasPulse
    pulse
    lastPulseTakenTime
    healthConditions
    relativesMedicalHistory
    hasOtherHealthConditions
    otherHealthConditions
    otherHealthConditionsDiagnosedRecently
    otherHealthConditionsDiagnosedRecentlyNotes
    takingMedicationsOrSupplements
    medicationsOrSupplements
    hasAllergies
    allergicReactionNotes
    allergies
    hadSurgeriesOrInjuries
    surgeriesOrInjuries
    lastDoctorVisitedTime
    hasAdditionalNotes
    additionalNotes
    gender
    pregnancyOrTryingPregnantOrBreastfeeding
    takingMedicationConsistentlyAndIsSatisfied
    notTakingMedicationOrUnsatisfiedNotes
    experiencingNewSideEffects
    experiencingNewSideEffectsNotes
    majorHealthOrLifestyleChange
    majorHealthOrLifestyleChangeNotes
    newMedicationOrAllergiesOrMedicalConditions
    newMedicationOrAllergiesOrMedicalConditionsNotes
    hasQuestionForDoctor
    hasQuestionForDoctorNotes
  }
`

export const COVE_USER_QUIZ_RESPONSE = gql`
  query CurrentLeadQuizResponse {
    user: currentLead {
      id
      activeJourneys {
        id
        coveQuizResponse {
          id
          ...CoveQuizResponseFragment
        }
      }
    }
  }
  ${QUIZ_RESPONSE_FRAGMENT}
`
